export const NAV_LINKS = [
  { label: 'How it works', href: '/how-it-works' },
  { label: 'Shop', href: '/shop' },
  { label: 'Become Partner', href: '/partner' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

export const STEPS = [
  { num: '01', title: 'Order your Connect tag', desc: 'Pick a Bike, Car or Both plan. Free delivery pan-India with COD available.' },
  { num: '02', title: 'Stick and activate', desc: 'Peel and place the waterproof tag on your windshield or bike. Activate in under a minute by linking your number — it stays hidden from here on.' },
  { num: '03', title: 'Anyone scans the QR', desc: 'A stranger scans with any phone camera. No app, no sign-up. A private page opens instantly.' },
  { num: '04', title: 'You stay completely private', desc: 'They call, SMS or WhatsApp you — all masked. Your real number is never exposed.' },
];

export const TRUST_BADGES = [
  { icon: 'ShieldCheck', title: '100% Privacy Protected', desc: 'Every call & message is routed through a masked layer.' },
  { icon: 'QrCode', title: 'Instant QR Contact', desc: 'No app to install. Any phone camera works out of the box.' },
  { icon: 'LifeBuoy', title: 'Roadside Help', desc: 'RSA across 500+ cities included with every tag.' },
  { icon: 'Wallet', title: 'Digital Vehicle Wallet', desc: 'RC, insurance, PUC — all encrypted, OTP protected.' },
  { icon: 'Wrench', title: 'Workshop & Maintenance History', desc: 'Every service, part & bill tracked in one timeline.' },
];

export const PRODUCTS = [
  {
    id: 'bike-mate',
    name: 'Bike',
    tagline: '1 Tag · For your bike',
    mrp: 599,
    price: 299,
    original: 599,
    image: 'bike',
    tag: '50% Startup Offer',
    features: ['1 Connect QR tag', 'Masked calls & WhatsApp', 'RSA help included', 'Service history tracking', 'Digital vehicle wallet', 'Smart PUC & insurance reminders', 'Emergency contact + blood group', 'Fuel & mileage tracker'],
  },
  {
    id: 'car-mate',
    name: 'Car',
    tagline: '2 Tags · Windshield + rear',
    mrp: 999,
    price: 499,
    original: 999,
    image: 'car',
    tag: 'Most popular · 50% Off',
    features: ['2 Connect QR tags', 'Masked calls & WhatsApp', 'RSA help included', 'Service history tracking', 'Digital vehicle wallet', 'Insurance claim support', 'Smart PUC & insurance reminders', 'Emergency contact + blood group', 'Fuel & mileage tracker'],
  },
  {
    id: 'combo',
    name: 'Combo',
    tagline: '1 Tag for Bike and 2 Tags for Car',
    mrp: 1399,
    price: 699,
    original: 1399,
    image: 'combo',
    tag: 'Best value · 50% Off',
    features: ['1 Bike tag + 2 Car tags', 'Masked calls & WhatsApp', 'Priority RSA help', 'Service history tracking', 'Digital vehicle wallet', 'Insurance claim support', 'Smart PUC & insurance reminders', 'Emergency contact + blood group', 'Fuel & mileage tracker'],
  },
];

export const APP_FEATURES = [
  { icon: 'Phone', title: 'Owner contact', desc: 'Masked call routing keeps your number hidden.' },
  { icon: 'HeartPulse', title: 'Emergency contact', desc: 'Add family or SOS numbers for accidents.' },
  { icon: 'Droplet', title: 'Blood group', desc: 'First responders see it instantly on scan.' },
  { icon: 'LifeBuoy', title: 'RSA help', desc: 'Roadside assistance across India.' },
  { icon: 'ShieldCheck', title: 'Insurance claim', desc: 'Guided claim support with documents.' },
  { icon: 'Wrench', title: 'Service history', desc: 'All service records in one timeline.' },
  { icon: 'Wallet', title: 'Digital vehicle wallet', desc: 'RC, insurance, PUC — OTP protected.' },
  { icon: 'BellRing', title: 'Smart reminders', desc: 'PUC, insurance, service due alerts.' },
];

export const PARTNER_TYPES = [
  {
    id: 'retailer',
    title: 'Retailer',
    icon: 'Store',
    tagline: 'Sell tags at your shop',
    perks: ['Bulk pricing from 20 units', 'Marketing kit included', 'Same-day dispatch', 'Monthly incentives'],
    price: 'Starts at 20 tags',
  },
  {
    id: 'distributor',
    title: 'Distributor',
    icon: 'Truck',
    tagline: 'Cover a district or state',
    perks: ['Exclusive territory rights', 'Dedicated relationship manager', 'Wholesale pricing', 'Co-branded campaigns'],
    price: 'Starts at 500 tags',
  },
  {
    id: 'franchise',
    title: 'Franchise',
    icon: 'Building2',
    tagline: 'Run a Connect Near Me outlet',
    perks: ['Store branding & fit-out support', 'Full training program', 'CRM & POS software', 'Regional lead sharing'],
    price: 'Investment-based',
  },
];

export const TESTIMONIALS = [
  { name: 'Rahul S.', city: 'Vadodara', quote: 'Someone parked behind me at a mall. One scan and I got the call within a minute. Brilliant.' },
  { name: 'Priya M.', city: 'Mumbai', quote: 'Love that my number stays private. Setup took less than a minute.' },
  { name: 'Arjun P.', city: 'Delhi', quote: 'Cheaper than a coffee for complete peace of mind. Everyone should have one.' },
];

export const INCLUDED = [
  'Masked audio & video calls',
  'WhatsApp notifications',
  'Roadside Assistance',
  'Emergency contact + blood group',
  'Service & maintenance history',
  'Digital vehicle wallet (RC/Insurance/PUC)',
  'Smart reminders (PUC/Insurance/Service)',
  'Live customer support',
];

export const COMPARISON = {
  columns: [
    { key: 'sampark', name: 'Sampark', highlight: false },
    { key: 'other', name: 'Share O Wheels', highlight: false },
    { key: 'cnm', name: 'Connect Near Me', highlight: true },
  ],
  rows: [
    { feature: 'Masked owner call', sampark: true, other: true, cnm: true },
    { feature: 'WhatsApp & SMS', sampark: true, other: false, cnm: true },
    { feature: 'Roadside Assistance (RSA)', sampark: false, other: false, cnm: true },
    { feature: 'Digital Vehicle Wallet (RC/PUC/Insurance)', sampark: false, other: false, cnm: true },
    { feature: 'Service & maintenance history', sampark: false, other: false, cnm: true },
    { feature: 'AI-style fuel & mileage tracker', sampark: false, other: false, cnm: true },
    { feature: 'Smart reminders via SMS', sampark: false, other: false, cnm: true },
    { feature: 'Emergency contact + blood group', sampark: true, other: true, cnm: true },
    { feature: 'Refer & earn program', sampark: false, other: false, cnm: true },
    { feature: 'Cashback via wallet points', sampark: false, other: false, cnm: true },
    { feature: 'Bike price (1 tag)', sampark: '₹499', other: '₹499', cnm: '₹299' },
    { feature: 'Car price (2 tags)', sampark: '₹499', other: '₹499', cnm: '₹499' },
    { feature: 'Family combo (bike + car)', sampark: '—', other: '—', cnm: '₹699' },
  ],
};

export const FOUNDER = {
  name: 'Mr. Dipsinh Dodiya',
  role: 'Founder & CEO',
  photo: '/dipsinh.jpg',
  bio: 'Mr. Dipsinh Dodiya successfully runs his own independent automobile workshop and brings over 16 years of hands-on expertise from India\u2019s most trusted automotive giants — Tata Motors, Maruti Suzuki and Toyota. His experience spans the full automotive spectrum — Research & Development (R&D), Sales, Service Operations, Vendor Management, and B2B/B2C business models. Combining his workshop-floor insight with deep OEM knowledge, Mr. Dodiya founded this Smart QR Vehicle Management Platform to solve the real-world problems he sees every day: privacy risks, parking disputes, breakdown chaos, and forgotten paperwork. His vision is simple: empower every vehicle owner in India with seamless privacy, instant emergency response, and intelligent vehicle management.',
  badges: [
    { icon: 'Award', title: '16+ Years Industry Expertise', desc: 'Deep-rooted knowledge across R&D, sales, service and supply chain.' },
    { icon: 'Wrench', title: 'Runs Independent Workshop', desc: 'Owns and operates a full-service automobile workshop.' },
    { icon: 'Building2', title: 'Ex-OEM Credentials', desc: 'Proven background with Tata Motors, Maruti Suzuki and Toyota.' },
    { icon: 'ShieldCheck', title: 'Safety & Privacy Pioneer', desc: 'Committed to privacy-first, tech-driven vehicle security solutions.' },
  ],
};

export const FUEL_TYPES = [
  { id: 'petrol', name: 'Petrol' },
  { id: 'diesel', name: 'Diesel' },
  { id: 'cng', name: 'CNG' },
  { id: 'electric', name: 'Electric' },
];

export const PARTNER_FAQS = [
  {
    q: 'Is my customer data safe? How does OTP protection work?',
    a: 'Absolutely. All customer data (RC, insurance, PUC, contact numbers) is encrypted at rest and is OTP-protected at every access — meaning a real-time one-time password is sent to the owner\'s registered mobile before any sensitive detail is shown. Partners never see raw customer numbers; every call and message is routed through a masked layer.',
  },
  {
    q: 'How can I become a Connect Near Me partner?',
    a: 'Choose your track — Retailer (20+ tags), Distributor (500+ tags) or Franchise (branded outlet). Just tap "Join / Contact Us" above, fill in your name, phone and city, and our onboarding team will reach out within 24 hours with pricing, marketing kit, training and a partner login. No setup fee for retailers.',
  },
  {
    q: 'How do partners earn — commissions, targets, payouts?',
    a: 'Partners earn a healthy commission on every tag sold under their code plus recurring incentives on renewals and add-on services (RSA, insurance leads). Commissions are auto-tracked in your Partner Dashboard and paid every 15 days via UPI/bank transfer. No hidden targets — earn on your very first sale.',
  },
  {
    q: 'What are reference points and how do they work?',
    a: 'Users earn 20 Points for every successful reference — where 1 Point = ₹1. Points are credited instantly to the wallet (for customers) or to the partner\'s payout ledger, and remain valid for 365 days. Fully transparent, stackable, and payable in cash — a simple way to reward you for growing the community.',
  },
];
